"use client";

import { AdminChatsPanel } from "@/components/admin-chats-panel";
import { GeneralFeedbackPanel } from "@/components/general-feedback-panel";
import { PageHeader } from "@/components/page-header";
import { MessageSquareTextIcon, MessagesSquareIcon } from "lucide-react";
import { useState } from "react";

type FeedbackView = "general" | "chat";

export function FeedbacksPanel({ onBack }: { onBack: () => void }) {
  const [view, setView] = useState<FeedbackView | null>(null);

  if (view === "general") {
    return <GeneralFeedbackPanel onBack={() => setView(null)} />;
  }

  if (view === "chat") {
    return <AdminChatsPanel onBack={() => setView(null)} />;
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <PageHeader
        variant="collection"
        title="Feedback"
        description="Review feedback submitted by Woods AI users."
        onBack={onBack}
      />
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto grid max-w-4xl grid-cols-1 gap-4 px-4 py-6 sm:grid-cols-2 sm:px-10 sm:py-10">
          <button
            type="button"
            onClick={() => setView("general")}
            className="flex min-h-36 flex-col items-start gap-3 rounded-lg border border-border bg-card p-5 text-left transition-colors hover:bg-accent/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <MessageSquareTextIcon className="size-5 text-muted-foreground" />
            <span className="space-y-1">
              <span className="block text-sm font-semibold text-foreground">
                General Feedback
              </span>
              <span className="block text-sm text-muted-foreground">
                Read feedback submitted without a chat or meeting context.
              </span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => setView("chat")}
            className="flex min-h-36 flex-col items-start gap-3 rounded-lg border border-border bg-card p-5 text-left transition-colors hover:bg-accent/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <MessagesSquareIcon className="size-5 text-muted-foreground" />
            <span className="space-y-1">
              <span className="block text-sm font-semibold text-foreground">
                Chat Feedback
              </span>
              <span className="block text-sm text-muted-foreground">
                Review feedback attached to chats and inspect shared conversations.
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
